import { ObservableFromFetch } from "../ObservableFromFetch"
import DaysToExclude from "./GovPoolModel/DaysToExclude"

export default function GetDaysToExclude(poolID: number = 0) {
  return ObservableFromFetch<DaysToExclude[]>(`GovPool/GetDaysToExclude?poolID=${poolID}`)
}